/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_GenerateInputs */

const cs_blog_ai_generate = /** @type {(inputs: Blog_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat článek`)
};

const en_blog_ai_generate = /** @type {(inputs: Blog_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate article`)
};

/**
* | output |
* | --- |
* | "Generate article" |
*
* @param {Blog_Ai_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_generate = /** @type {((inputs?: Blog_Ai_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_generate(inputs)
	return cs_blog_ai_generate(inputs)
});